module.exports = __webpack_public_path__ + "static/img/member_twenty_discount.5219eb08.png";